import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-import',
  standalone: true,
  imports: [],
  templateUrl: './icon-import.component.html',
  styleUrl: './icon-import.component.scss'
})
export class IconImportComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24px';
}
